import { type ReactElement } from 'react';

export function FRMAccountSearchMessage(): ReactElement {
  return <div>FRM Account Search</div>;
}
